import { FunctionComponent } from "react";
import styles from "./footer.module.css";
import { Link } from "react-router-dom";

const Footer: FunctionComponent = () => {
  return (
    <div className={styles.frameParent}>
      <div className={styles.frameGroup}>
        <div className={styles.frameContainer}>
          <div className={styles.image127Parent}>
            <img
              className={styles.image127Icon}
              alt=""
              src="./assets/logo.png"
            />
            <div
              className={styles.collectionInfrastructureTo}
            >{`Collection Infrastructure to increase your recovery. Omnichannel to solve all your debt Collection Challenges. `}</div>
          </div>
          <div className={styles.operationalOfficeAddress21Parent}>
            <div className={styles.collectionInfrastructureTo}>
              <p className={styles.operationalOfficeAddress}>
                Operational Office Address:
              </p>
              <p
                className={styles.operationalOfficeAddress}
              >{`213 - 214, Welldone Tech Park, `}</p>
              <p className={styles.operationalOfficeAddress}>
                Badshahpur Sohna Rd Hwy, Sector 48, Gurugram, Haryana 122001
              </p>
            </div>
            <div className={styles.collectionInfrastructureTo}>
              <p
                // className={styles.operationalOfficeAddress , styles.registeredOfficeAddress}
                className={`${styles.operationalOfficeAddress} ${styles.registeredOfficeAddress}`}
              >{`Registered Office Address: `}</p>
              <p className={styles.operationalOfficeAddress}>
                32 14th,Vignananagar, Doddanekkundi, Bangalore North, Bangalore
                - 560037, Karnataka
              </p>
            </div>
          </div>
        </div>
        <div className={styles.image217Wrapper}>
          <img
            className={styles.image217Icon}
            alt=""
            src="./assets/footerc.png"
          />
        </div>
      </div>
      <div className={styles.frameDiv}>
        <div className={styles.frameParent1}>
          <div className={styles.frameParent2}>
            <div className={styles.platformParent}>
              {/* <div className={styles.platform}>Platform</div> */}
              <div className={styles.list}>
                {/* <div className={styles.image217Wrapper}>
									<Link to="/about-us" onClick={() => window.scrollTo(0, 0)} style={{ textDecoration: 'none', color: 'inherit' }}>
										<div className={styles.text}>About Us</div>
									</Link>
								</div> */}
                {/* <div className={styles.text}>Pricing</div>
								<div className={styles.text}>API</div>
								<div className={styles.text}>Get a Demo</div> */}
                <Link
                  to="/contact-sales"
                  onClick={() => window.scrollTo(0, 0)}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  {/* <div className={styles.text}>Contacts</div> */}
                </Link>
                {/* <div className={styles.text}>Careers</div> */}
              </div>
            </div>
            <div className={styles.legalParent}>
              {/* <div className={styles.platform}>Legal</div> */}
              <div className={styles.list}>
                <a
                  href="./assets/privacypolicy.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div className={styles.text}>Privacy Policy</div>
                </a>

                <a
                  href="./assets/terms.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div className={styles.text}>Terms Of Use</div>
                </a>

                <div
                  className={styles.text}
                  onClick={() => {
                    const section = document.getElementById("section2");
                    if (section) {
                      section.scrollIntoView({ behavior: "smooth" });
                    }
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Compliance
                </div>

                <a
                  href="./assets/cookies.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div className={styles.text}>Cookie Policy</div>
                </a>
                {/* <div className={styles.text}>Case Studies</div> */}
                {/* <div className={styles.text}>FAQ’s</div> */}
              </div>
            </div>
          </div>
          <div className={styles.linkLinkedinQ6ebac497pParent}>
            <a
              href="https://www.linkedin.com/company/credresolve/" // URL you want to open
              target="_blank" // Opens in a new tab
              rel="noopener noreferrer" // Security best practice when opening links in new tab
            >
              <img
                className={styles.linkLinkedinQ6ebac497p}
                alt="LinkedIn Icon"
                src="./assets/linkedin.png"
              />
            </a>

            {/* <a
							href="https://www.instagram.com/credresolve_/?igsh=MWFvMDhzdndleXdycg%3D%3D#"
							target="_blank"
							rel="noopener noreferrer"
						>
							<img
								className={styles.linkLinkedinQ6ebac497p}
								alt="Instagram Icon"
								src="./assets/instagram.png"
							/>
						</a> */}

            {/* <img className={styles.frameChild} alt="" src="./assets/twitter.png" /> */}
          </div>
        </div>
        <div className={styles.telephone9876543210Container}>
          <p
            className={styles.operationalOfficeAddress}
          >{`Telephone:9557027272`}</p>
          <p
            className={styles.operationalOfficeAddress}
          >{`Email:dhiraj.chiruvella@credresolve.com`}</p>

          <p className={styles.operationalOfficeAddress}>
            © 2023 Credhas Technology Private Limited | All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
